<template>
    <div class="codes-content" v-if="activeClient && activeClient.codes">
        <div class="info-row">
            <span class="row-title">ODOO</span>
            <span class="row-value">{{ odooCodesString || "-" }}</span>
        </div>
        <div class="info-row">
            <span class="row-title">SMARTEN</span>
            <span class="row-value">{{ smartenCodesString || "-" }}</span>
        </div>
        <div class="info-row">
            <span class="row-title">EUGESTA</span>
            <span class="row-value">{{ eugestaCodesString || "-" }}</span>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "client-codes-tab",
    computed: {
        ...mapState("ClientStore", ["activeClient"]),
        odooCodesString() {
            if (!this.activeClient || !this.activeClient.codes) return "";
            const codes = this.activeClient.codes
                .filter(c => c.partner === "odoo")
                .map(c => c.code);
            return codes.join(", ");
        },
        smartenCodesString() {
            if (!this.activeClient || !this.activeClient.codes) return "";
            const codes = this.activeClient.codes
                .filter(c => c.partner === "smarten")
                .map(c => c.code);
            return codes.join(", ");
        },
        eugestaCodesString() {
            if (!this.activeClient || !this.activeClient.codes) return "";
            const codes = this.activeClient.codes
                .filter(c => c.partner === "eugesta")
                .map(c => c.code);
            return codes.join(", ");
        }
    }
};
</script>

<style scoped>
.codes-content {
    padding: 0 20px 12px 20px;
}

.info-row {
    display: flex;
    align-items: center;
    min-height: 24px;
    line-height: 1.3;
}

.row-title {
    color: #888;
    width: 140px;
    flex-shrink: 0;
    font-size: 13px;
}

.row-value {
    font-size: 13px;
    color: #333;
}
</style>
